import Header from "./components/Header/Header";
import Lesson from "./components/pages/Lesson";
import "./index.css"


function App() {
  return (
    <div>
      <Header/>
      <Lesson/>
    </div>
  )
}

export default App;
